import { useState } from 'react';
import { INSET_X, LINE } from '@/components/base/Frame';

interface FrictionItem {
  index: string;
  title: string;
  desc: string;
}

/*
 * Hover pattern (same as home Services):
 * - one row active at a time, owned by state;
 * - tint + left rule are separate layers, only opacity animates;
 * - fade in on enter, instant off when switching rows.
 */
export default function FrictionList({ items, className = '' }: { items: FrictionItem[]; className?: string }) {
  const [active, setActive] = useState<string | null>(null);

  return (
    <ul className={`border-t ${LINE} ${className}`} onPointerLeave={() => setActive(null)}>
      {items.map((f) => {
        const on = active === f.index;
        const fade = on ? 'opacity-100 transition-opacity duration-200 ease-out' : 'opacity-0';
        return (
          <li
            key={f.index}
            onPointerEnter={(e) => { if (e.pointerType === 'mouse') setActive(f.index); }}
            className={`relative grid grid-cols-[40px_1fr] items-baseline gap-x-4 gap-y-1 border-b ${LINE} bg-white py-5 md:grid-cols-[56px_minmax(0,4fr)_minmax(0,7fr)] md:gap-x-8 ${INSET_X}`}
          >
            <span aria-hidden="true" className={`pointer-events-none absolute inset-0 bg-primary-50/70 will-change-[opacity] ${fade}`} />
            <span aria-hidden="true" className={`pointer-events-none absolute inset-y-0 left-0 w-px bg-primary-400 will-change-[opacity] ${fade}`} />
            <span className="relative font-label text-xs tracking-[0.1em] text-primary-500">{f.index}</span>
            <h3 className="relative text-2xl font-light tracking-[-0.015em] text-foreground-950 lg:text-[26px]">{f.title}</h3>
            <p className="relative col-start-2 text-base leading-relaxed text-foreground-700 md:col-start-3 md:row-start-1">{f.desc}</p>
          </li>
        );
      })}
    </ul>
  );
}